import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgHeadphones = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-headphones';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.34 3.28c-3.109.223-5.933 2.157-7.259 4.971a9.4 9.4 0 0 0-.747 2.429c-.064.382-.071.859-.084 5.25l-.013 4.83H9.24v-7.52H4.751l.02-1.09c.013-.754.039-1.193.083-1.424.289-1.517.943-2.768 2.004-3.828 1.77-1.77 4.218-2.494 6.692-1.978 2.187.456 4.143 2.041 5.06 4.1.48 1.077.592 1.643.619 3.13l.02 1.09H15.24v7.52h5.52v-4.55c0-2.858-.016-4.721-.042-5.01a8.6 8.6 0 0 0-2.495-5.344c-.778-.779-1.406-1.23-2.363-1.699a8.75 8.75 0 0 0-4.52-.877M7.76 17v2.24h-3v-4.48h3zm11.48 0v2.24h-2.48v-4.48h2.48z"
    })
  }));
});
export default SvgHeadphones;